import React from "react";
import useService from "../../../hooks/useServices";
import Service from "../Service/Service";
import "./Services.css";

const Services = () => {
  const { service } = useService();
  console.log(service);
  return (
    <div className="py-10 lg:py-10">
      <h2 className="lg:text-4xl text-2xl font-bold title-design">
        Our Services
      </h2>
      <div className="xl:mx-32 sm:mx-0 grid xl:grid-cols-3  lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-4 pt-12 mx-5 lg:mx-12">
        {service.map((service) => (
          <Service key={service.id} service={service}></Service>
        ))}
      </div>
    </div>
  );
};

export default Services;
